<template>
  <div>
    <v-data-iterator
      :items="paginatedItems"
      :items-per-page.sync="itemsPerPage"
      hide-default-footer
    >
      <template #default="props">
        <v-row>
          <v-col>
            <EventCard
              v-for="item in props.items"
              :key="item.name"
              :event="item"
              :schools="schools"
              class="mb-5"
              @editDialogToggled="toggleEditDialog"
              @openStudentRegistration="toggleStudentRegistrationDialog"
              @eventCancelled="fetchEvents(item,'cancelled')"
            />
          </v-col>
        </v-row>
      </template>

      <template #footer>
        <v-row>
          <v-col>
            <div class="d-flex justify-end">
              <v-pagination
                v-model="currentPage"
                :length="totalPages"
                class="my-5"
              />
            </div>
          </v-col>
        </v-row>

      </template>
    </v-data-iterator>
    <FullscreenDialog
      v-if="showEditDialog"
      :title="`${dulplicateEvent ? 'Duplicate' : 'Edit'} event`"
      v-model="showEditDialog"
      :showCloseButton="false"
    >
      <template #content>
        <EditEvent
          v-if="showEditDialog"
          @eventEdited="toggleEditDialog"
          :dulplicate-event="dulplicateEvent"
          :event="eventToEdit"
        />
      </template>
    </FullscreenDialog>

    <FullscreenDialog
      v-if="eventToEdit"
      title="Add registrations"
      v-model="showStudentRegistrationDialog"
    >
      <template #content>
        <StudentRegistration
          v-if="eventToRegister"
          :event="eventToRegister"
          :is-dialog-open="showStudentRegistrationDialog"
          @closeAndSave="toggleStudentRegistrationDialog"
        />
      </template>
    </FullscreenDialog>
  </div>
</template>

<script>
import EventCard from '@/components/EventCard/index.vue';
import StudentRegistration from '@/components/StudentRegistration/index.vue';
import EditEvent from '@/components/EditEvent/index.vue';
import { FullscreenDialog } from '@nswdoe/doe-ui-core';

export default {
  name: 'EventList',
  components: {
    EditEvent,
    EventCard,
    FullscreenDialog,
    StudentRegistration,
  },
  props: {
    events: {
      type: Array,
      required: true
    },
    schools: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      default: 20
    },
    listType: {
      type: String,
      default: 'upcoming'
    }
  },

  data() {
    return {
      currentPage: 1,
      itemsPerPage: 20,
      eventToEdit: {},
      dulplicateEvent: {},
      showEditDialog: false,
      showStudentRegistrationDialog: false,
      eventToRegister: {},
    };
  },
  watch: {
    'events': {
      deep: true,
      handler() {
        this.currentPage = 1;
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.events.length / this.perPage);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.events.slice(start, end);
    }
  },
  methods: {
    fetchEvents(eventUpdated, action) {
      this.$emit('onUpdate', eventUpdated, action);
    },
    toggleEditDialog(event, duplicateFlag = false, changed = false) {
      this.changed = changed;
      this.eventTitle = this.eventToEdit.title;
      this.eventToEdit = {};
      this.eventToEdit = event;
      this.dulplicateEvent = duplicateFlag;
      this.showEditDialog = !this.showEditDialog;
      if (!this.showEditDialog && changed) {
        this.fetchEvents(event, duplicateFlag ? 'duplicated':'updated');
      }
    },
    toggleStudentRegistrationDialog(event) {
      if (this.showStudentRegistrationDialog) {
        this.eventToRegister = null;
        this.fetchEvents(event, 'updated');
      } else {
        this.eventToRegister = event;
        this.showStudentRegistrationDialog = true;
      }
    },
  }
};
</script>

<style scoped>
.pagination button.active {
  font-weight: bold;
  background: #eee;
}
</style>
